import { Divider, Stack, Text } from '@mantine/core';

import { AbstractValidationAction } from '@/module/Author/Abstract/Validation/AbstractValidationAction';
import { AbstractValidationHistory } from '@/module/Author/Abstract/Validation/AbstractValidationHistory';
import { AbstractDeleteButton } from '@/module/Author/Abstract/components/AbstractDeleteButton';
import { AbstractImpactFactor } from '@/module/Author/Abstract/components/AbstractImpactFactor';
import { AbstractInfluence } from '@/module/Author/Abstract/components/AbstractInfluence';
import { PaperContent } from '@/module/Author/Paper/components/PaperContent';
import { PublicationContent } from '@/module/Author/Publication/components/PublicationContent';

import { Content, EditButtonLink } from '@/core/components';

import { AuthorList } from '@feature/utils';
import { ConferenceLink } from '@feature/utils/components/ConferenceLink';

import { ViewCitationsButton } from '../Citation/components/ViewCitationsButton';
import { Abstract } from './model/AbstractTypes';

interface AbstractViewProps {
  abstract: Abstract;
}

export function AbstractView({ abstract }: AbstractViewProps) {
  const { authors, volumeIsbn, conference } = abstract;

  return (
    <Stack>
      <PublicationContent
        publication={abstract}
        authorsNo={authors.length}
        actions={
          <>
            <EditButtonLink
              size="xs"
              miw="100px"
            />
            <AbstractDeleteButton abstractId={abstract.id} />
          </>
        }
      />
      <ViewCitationsButton
        entityId={abstract.id}
        entityType="ABSTRACT"
      />
      <Content type="full">
        {conference && (
          <ConferenceLink
            conferenceId={conference.id}
            title={conference?.conferenceName}
          />
        )}
        {volumeIsbn && <Text>ISBN Volum: {volumeIsbn}</Text>}
      </Content>
      <PaperContent
        paper={abstract}
        metrics={
          <Stack>
            <AbstractImpactFactor abstractId={abstract.id} />
            <Divider />
            <AbstractInfluence abstractId={abstract.id} />
          </Stack>
        }
      />
      <Content type="full">
        <AuthorList authors={authors} />
      </Content>
      <AbstractValidationAction abstractId={abstract.id} />
      <AbstractValidationHistory abstractId={abstract.id} />
    </Stack>
  );
}
